import { useNotification as useNotificationContext } from '../contexts/NotificationContext';

// Re-export the hook for convenience
export const useNotification = useNotificationContext;